import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Keep access token in memory for WebSocket / file downloads
let accessToken = null;
export const setAccessToken = (t) => {
  accessToken = t;
  if (t) localStorage.setItem("cs_token", t);
  else localStorage.removeItem("cs_token");
};
export const getAccessToken = () => accessToken || localStorage.getItem("cs_token");

api.interceptors.request.use((config) => {
  const t = getAccessToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  if (centerId) config.headers["X-Center-Id"] = centerId;
  return config;
});

let centerId = localStorage.getItem("cs_center") || null;
export const setCenterId = (id) => {
  centerId = id;
  if (id) localStorage.setItem("cs_center", id);
  else localStorage.removeItem("cs_center");
};
export const getCenterId = () => centerId;

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const wsUrl = () => {
  const base = BACKEND_URL.replace(/^http/, "ws");
  return `${base}/api/chat/ws?token=${encodeURIComponent(getAccessToken() || "")}`;
};

export const fileDownloadUrl = (fileId) =>
  `${API}/files/${fileId}/download?auth=${encodeURIComponent(getAccessToken() || "")}`;

export default api;
